import kawasan0 from '../../../src/media/Fasilitas/Kawasan SCG.webp'
import Kawasan1 from '../../../src/media/Kawasan/Kawasan (1).webp'
import Kawasan2 from '../../../src/media/Kawasan/Kawasan (2).webp'
import Kawasan3 from '../../../src/media/Kawasan/Kawasan (3).webp'
import Kawasan4 from '../../../src/media/Kawasan/Kawasan (4).webp'
import Kawasan5 from '../../../src/media/Kawasan/Kawasan (5).webp'
import Kawasan6 from '../../../src/media/Kawasan/Kawasan (6).webp'
import Kawasan7 from '../../../src/media/Fasilitas/Kawasan (1).webp'
import Kawasan8 from '../../../src/media/Fasilitas/Kawasan (2).webp'
import Kawasan9 from '../../../src/media/Fasilitas/Kawasan (3).webp'
import Kawasan10 from '../../../src/media/Kawasan/Kawasan (7).webp'
import Kawasan11 from '../../../src/media/Fasilitas/Kawasan Jasmia (2).webp'
import Kawasan12 from '../../../src/media/Kawasan/Kawasan (8).webp'
import Kawasan13 from '../../../src/media/Fasilitas/Kawasan Regia (1).webp'
import Kawasan14 from '../../../src/media/Kawasan/Kawasan (9).webp'
import Kawasan15 from '../../../src/media/Kawasan/Kawasan (10).webp'
import Kawasan16 from '../../../src/media/Fasilitas/Kawasan (5).webp'


const Kawasanimages =[
kawasan0,Kawasan1,Kawasan2,Kawasan3,Kawasan4,Kawasan5,Kawasan6,Kawasan7,Kawasan8,Kawasan9,Kawasan10,Kawasan11,Kawasan12,Kawasan13,Kawasan14,Kawasan15,Kawasan16
]

export default Kawasanimages;